import React from "react";

/**
 * Official Conlang Book House logo.
 * Uses the final crimson book+quill+CBH mark provided by the brand.
 * Variants: "dark" (natural on ivory) | "light" (for dark backgrounds — brightened border/wordmark colour cues) | "gold"
 */
export const CBHLogo = ({ variant = "dark", showWordmark = false, className = "" }) => {
  // The final mark is a self-contained lockup (art + CBH + Conlang Book House + tagline).
  // We ship it as an <img> so the crimson serif rendering stays consistent everywhere.
  const src = "/brand/cbh-logo.webp";
  const isLight = variant === "light";

  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="cbh-logo"
      aria-label="Conlang Book House"
    >
      <img
        src={src}
        alt="Conlang Book House — Where Ideas Become Legacy"
        className={`h-14 md:h-16 w-auto object-contain ${isLight ? "invert-0 brightness-110 contrast-125" : ""}`}
        style={isLight ? { filter: "brightness(0) invert(1)" } : undefined}
        loading="eager"
        decoding="async"
      />
      {showWordmark && null}
    </div>
  );
};

export default CBHLogo;
